export const TWG_BRANDING = 'Teamwork Graph';
export const ATLASSIAN_BRANDING = 'Atlassian';
